import { createContext, useState } from 'react';

const SettingChangeContext = createContext({});

function useSettingChangeContext() {
  const [selectdSettingKey, setSelectedSettingKey] = useState(''); // 设置的主分类，例如【对话设置】
  const [selectItemKey, setSelectItemKey] = useState(''); // 子选项的 key，例如【对话设置】的【训前表单】的 key
  return {
    selectdSettingKey,
    setSelectedSettingKey,
    selectItemKey,
    setSelectItemKey
  };
}

useSettingChangeContext.SettingChangeContext = SettingChangeContext;

export default useSettingChangeContext;
